var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 27.5,
  height: 27.5,
  x: 0.25,
  y: 0.25,
  stroke: "#000",
  strokeWidth: 0.5,
  rx: 1.75
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.6,
  d: "m18.85 10.65-3.5-3.5c-.1-.1-.2-.15-.35-.15h-5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-9c0-.15-.05-.25-.15-.35M15 8.2l2.8 2.8H15zM18 20h-8V8h4v3c0 .55.45 1 1 1h3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.6,
  d: "M11 17h6v1h-6zm0-3h6v1h-6z"
})));
export { SvgDocument as ReactComponent };
export default __webpack_public_path__ + "811a86ac82fe27261656221f37fbe927.svg";